import { render, staticRenderFns } from "./iatIntro.vue?vue&type=template&id=fd23308a"
import script from "./iatIntro.vue?vue&type=script&lang=js"
export * from "./iatIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports